var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',{staticClass:"k-landing-main"},[_c('div',{staticClass:"k-landing-main__layout"},[_c('the-header'),_vm._v(" "),_vm._t("nuxt",function(){return [_c('nuxt')]})],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }